import {
    Component,
    OnInit,
    ElementRef,
    Output,
    ViewChild,
    Input,
    EventEmitter,
    OnDestroy,
    Injector,
} from '@angular/core';
import { TournamentsService } from '../tournaments/services/tournaments.service';
import { Observable, Subscription, timer } from 'rxjs';
import { Router } from '@angular/router';
import { lg } from '~/modules/colorLog';
import { uiHelper } from '../../../helpers/ui.helper';
import { AppComponentBase } from '../../../shared/app-component-base';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_slipdetail',
    templateUrl: './slipdetail.html',
})
export class SlipDetail extends AppComponentBase implements OnInit, OnDestroy {
    constructor(
        public tournamentsService: TournamentsService,
        public router: Router,
        private _uiHelper: uiHelper,
        private _injector: Injector,
    ) {
        super(_injector);
    }

    idlecounter = 0;
    subsidleResetListener;
    ngOnInit() {
        // console.warn(this.tournamentsService.SlipCashOutSlipNumber, 'slipDetail');

        if (this.tournamentsService.SlipCashOutSlipNumber != 0) {
            this.tournamentsService.getSlipDetail_Terminal();
            this.RefreshSlipDetail();
        } else {
            this.router.navigate(['/LiveBets']);
            // todo if it zero, that means app reload or app open this route but slipnumber not defined. program navigate to live bets.
            lg('SLIP DETAIL', 'this.tournamentsService.SlipCashOutSlipNumber is zero.');
        }

        SetLanguage('', '');
        this.subsidleResetListener = this._uiHelper.idleResetListener.subscribe(s => {
            this.slipDetail_Back_Button();
        });
    }

    RefreshSlipDetail() {
        if (this.tournamentsService.slipdetail_subClientCO != undefined)
            this.tournamentsService.slipdetail_subClientCO.unsubscribe();

        this.tournamentsService.timer_slipdetail = timer(11000, 12000);

        this.tournamentsService.slipdetail_subClientCO = this.tournamentsService.timer_slipdetail.subscribe(t => {
            this.tournamentsService.getSlipDetailRefresh_Terminal();
            this.idlecounter++;
            if (this.idlecounter > 9) {
                this.slipDetail_Back_Button();
            }
        });
    }

    ngOnDestroy() {
        if (this.tournamentsService.slipdetail_subClientCO != undefined) {
            this.tournamentsService.slipdetail_subClientCO.unsubscribe();
        }

        clearInterval(this.tournamentsService.timer_slipdetail);
        this.tournamentsService.timer_slipdetail = null;

        this.tournamentsService.clear_SlipDetail_Cashout_Counter();

        if (this.subsidleResetListener != undefined) {
            this.subsidleResetListener.unsubscribe();
            this.subsidleResetListener = undefined;
        }
    }

    slipDetail_Back_Button() {
        if (this.tournamentsService.slipdetail_subClientCO != undefined) {
            this.tournamentsService.slipdetail_subClientCO.unsubscribe();
        }

        this.tournamentsService.clear_SlipDetail_Cashout_Counter();
        this.router.navigate(['/LiveBets']);
    }

    OpenLiveTrackerModal(fixtureItem) {
        this._uiHelper.setLiveTrackerModalParameter(fixtureItem.MatchId);
        let thiss = this;
        let timeFunc;
        $('#Livetracker_Modal')
            .modal({
                detachable: false,

                onShow: function() {
                    timeFunc = setTimeout(() => {
                        $('#Livetracker_Modal').modal('hide');
                    }, 180000);
                },

                onHidden: function() {
                    clearTimeout(timeFunc);
                    thiss._uiHelper.LivetrackerModalClose(true);
                },
            })
            .modal('show');
    }
}
